import {PageContinueDto} from '../../common/shared/api/nicolas/vo/PageContinueDto.interface';
import {ContinueInfo, ContinueProductType} from '../generated/types';

export function createContinueInfo(
  {
    first_read_is_free,
    first_read_product_id,
    first_read_product_title,
    last_read_product_id,
    last_read_product_title,
    next_read_product_id,
    next_read_product_title,
    has_new_single,
    has_unread_single,
  }: PageContinueDto,
  seriesId?: number
): ContinueInfo {
  const continueProductType =
    !next_read_product_id && !last_read_product_id
      ? ContinueProductType.First
      : next_read_product_id !== undefined &&
          last_read_product_id !== next_read_product_id // 마지막 읽은 회차를 끝까지 읽은 경우(is_done = true), next_read_product_id 는 다음 회차로 넘어옵니다. 이 경우 '다음화 보기'를 보여줍니다
        ? ContinueProductType.Next
        : ContinueProductType.Last;

  const {productId, title} =
    continueProductType === ContinueProductType.First
      ? {productId: first_read_product_id, title: first_read_product_title}
      : continueProductType === ContinueProductType.Next
        ? {productId: next_read_product_id, title: next_read_product_title}
        : {productId: last_read_product_id, title: last_read_product_title};

  if (!productId) {
    throw new Error('회차 정보가 없습니다');
  }

  return {
    continueProductType,
    productId,
    lastReadProductId: last_read_product_id,
    title,
    scheme: `kakaopage://open/viewer?product_id=${productId}&series_id=${seriesId}`,
    isFree:
      continueProductType === ContinueProductType.First && first_read_is_free,
    hasNewSingle: has_new_single,
    hasUnreadSingle: has_unread_single,
  };
}
